import React from "react";
import { RouteComponentProps } from "react-router";

import { initNavigator } from "shared/services/navigator";

export interface IWithNavigatorProps extends RouteComponentProps<{}> {}

export default function withNavigator(
  WrappedComponent: React.ComponentType<
    React.PropsWithChildren<IWithNavigatorProps>
  >
): React.ComponentType<React.PropsWithChildren<IWithNavigatorProps>> {
  return class extends React.Component<IWithNavigatorProps> {
    constructor(props: IWithNavigatorProps) {
      super(props);

      initNavigator({
        history: props.history,
        location: props.location,
        match: props.match,
      });
    }

    public render() {
      return <WrappedComponent {...this.props} />;
    }
  };
}
